var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-copy"},[_c('div',{staticClass:"toast-copy-content"},[_c('span',[_vm._v(_vm._s(_vm.$t('copied')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }